import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { leaders } from '../mock';
import { useTranslation } from '../i18n/LanguageContext';

const LeadershipPage = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="text-white py-24 md:py-36 relative overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url('/images/holy-fire-bg.jpg')" }}></div>
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center space-y-8 fade-in">
            <Badge variant="secondary" className="bg-white/20 text-white border-white/30 uppercase tracking-[0.3em] text-xs">
              {t('leadership.badge')}
            </Badge>
            <h1 className="display-hero text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              {t('leadership.heroTitle')} <span className="italic font-light">{t('leadership.heroAccent')}</span>
            </h1>
            <p className="text-lg md:text-xl text-white/85 max-w-2xl mx-auto">
              {t('leadership.heroSubtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Leadership Grid */}
      <section className="py-24 md:py-32 bg-background">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
            {leaders.map((leader) => (
              <Card 
                key={leader.id} 
                className="overflow-hidden card-hover group rounded-2xl border-0"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={leader.image}
                    alt={leader.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    style={{ objectPosition: 'center 20%' }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <p className="uppercase tracking-[0.25em] text-[10px] text-white/80 mb-2">{t(leader.role)}</p>
                    <h3 className="display-hero text-2xl md:text-3xl">{leader.name}</h3>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LeadershipPage;
